import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout, isAdmin } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* 手机端顶部登录按钮栏（仅未登录时显示） */}
      {!isAuthenticated && (
        <div className="top-bar top-bar-mobile">
          <div className="top-bar-content">
            <Link to="/login" className="btn btn-login">
              登录
            </Link>
          </div>
        </div>
      )}

      {/* 桌面端导航栏 */}
      <nav className="navbar navbar-desktop">
        <div className="navbar-content">
          <div className="navbar-logo">北海红色人物数字博物馆</div>
          <div className="navbar-right">
            {isAuthenticated ? (
              <>
                <ul className="navbar-links">
                  <li>
                    <Link
                      to="/"
                      className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
                    >
                      首页
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/heroes"
                      className={`navbar-link ${location.pathname === '/heroes' ? 'active' : ''}`}
                    >
                      英雄档案馆
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/quiz"
                      className={`navbar-link ${location.pathname === '/quiz' ? 'active' : ''}`}
                    >
                      答题闯关区
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/workshop"
                      className={`navbar-link ${location.pathname === '/workshop' ? 'active' : ''}`}
                    >
                      红色创客营
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/profile"
                      className={`navbar-link ${location.pathname === '/profile' ? 'active' : ''}`}
                    >
                      我的
                    </Link>
                  </li>
                  {isAdmin && (
                    <li>
                      <Link
                        to="/admin"
                        className={`navbar-link ${location.pathname === '/admin' ? 'active' : ''}`}
                      >
                        审核管理
                      </Link>
                    </li>
                  )}
                </ul>
                <button onClick={handleLogout} className="btn btn-logout btn-desktop">
                  退出
                </button>
              </>
            ) : (
              <Link to="/login" className="btn btn-login btn-desktop">
                登录
              </Link>
            )}
          </div>
        </div>
      </nav>
      
      {/* 手机端底部导航栏 */}
      {isAuthenticated && (
        <nav className="navbar navbar-mobile">
          <ul className="navbar-mobile-links">
            <li>
              <Link
                to="/"
                className={`navbar-mobile-link ${location.pathname === '/' ? 'active' : ''}`}
              >
                <img src="/home.svg" alt="首页" className="navbar-icon" />
                <span className="navbar-text">首页</span>
              </Link>
            </li>
            <li>
              <Link
                to="/heroes"
                className={`navbar-mobile-link ${location.pathname === '/heroes' ? 'active' : ''}`}
              >
                <img src="/hero.svg" alt="英雄" className="navbar-icon" />
                <span className="navbar-text">英雄</span>
              </Link>
            </li>
            <li>
              <Link
                to="/quiz"
                className={`navbar-mobile-link ${location.pathname === '/quiz' ? 'active' : ''}`}
              >
                <img src="/timu.svg" alt="答题" className="navbar-icon" />
                <span className="navbar-text">答题</span>
              </Link>
            </li>
            <li>
              <Link
                to="/workshop"
                className={`navbar-mobile-link ${location.pathname === '/workshop' ? 'active' : ''}`}
              >
                <img src="/chuangke.svg" alt="创客" className="navbar-icon" />
                <span className="navbar-text">创客</span>
              </Link>
            </li>
            <li>
              <Link
                to="/profile"
                className={`navbar-mobile-link ${location.pathname === '/profile' ? 'active' : ''}`}
              >
                <img src="/my.svg" alt="我的" className="navbar-icon" />
                <span className="navbar-text">我的</span>
              </Link>
            </li>
            {isAdmin && (
              <li>
                <Link
                  to="/admin"
                  className={`navbar-mobile-link ${location.pathname === '/admin' ? 'active' : ''}`}
                >
                  <img src="/admin.svg" alt="审核" className="navbar-icon" />
                  <span className="navbar-text">审核</span>
                </Link>
              </li>
            )}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Navbar;

